document.addEventListener('DOMContentLoaded', () => {
  const addToBoxButtons = document.querySelectorAll('[data-add-to-box]');
  const addToCartBtn = document.querySelector('[data-add-box-to-cart]');
  const saveToCartBtn = document.querySelector('[data-save-box-to-cart]');
  const addToCartMobile = document.querySelector('.js-add-to-cart-mobile');
  const addOnCheckbox = document.querySelector('[data-add-on-product-id]');
  const emptySvgHTML = '<svg width="107" height="107" viewBox="0 0 107 107" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="107" height="107" fill="#E0E0E0"/><path d="M53.5 33.8125C48.2982 33.8756 43.3272 35.9701 39.6486 39.6486C35.9701 43.3272 33.8756 48.2982 33.8125 53.5C33.8756 58.7018 35.9701 63.6728 39.6486 67.3514C43.3272 71.0299 48.2982 73.1244 53.5 73.1875C58.7018 73.1244 63.6728 71.0299 67.3514 67.3514C71.0299 63.6728 73.1244 58.7018 73.1875 53.5C73.1244 48.2982 71.0299 43.3272 67.3514 39.6486C63.6728 35.9701 58.7018 33.8756 53.5 33.8125ZM64.75 54.9063L54.9063 54.9063L54.9063 64.75L52.0938 64.75L52.0938 54.9063L42.25 54.9063L42.25 52.0938L52.0938 52.0938L52.0938 42.25L54.9063 42.25L54.9063 52.0938L64.75 52.0938L64.75 54.9063Z" fill="white" fill-opacity="0.8"/></svg>';
  let handlesList = [];
  let selectedProducts = [];
  let sizeValue = 0;
  let addImgCount = 0;

  if (localStorage.getItem("selectedProducts") && !window.location.href.includes('#box_id') && document.getElementById('box-container')) {
    const storageHandlesList = JSON.parse(localStorage.getItem('handlesList'));
    const storageSelectedProducts = JSON.parse(localStorage.getItem('selectedProducts'));
    storageHandlesList.forEach((item) => {
      const currentProduct = storageSelectedProducts.find((el) => {
        return el.handle === item;
      })
      if (currentProduct) {
        const currentInput = document.querySelector(`input[data-id="${currentProduct.id}"]`);
        const currentImage = currentInput.getAttribute('data-image');
        const currentSize = currentInput.getAttribute('data-box-size');
        const currentCase = currentInput.getAttribute('data-case');
        currentInput.value = currentProduct.quantity;
        setImages(currentImage, currentSize, currentCase, currentProduct.id, item);
        recalculate();
      }
    })
  }

  async function productFromCart(boxId) {
    try {
      const getCurrentCart = await (await fetch('/cart.js')).json();
      let boxItem;

      if (BUNDLE_LOGIC === "custom") {
        boxItem = getCurrentCart.items.filter(item => item.properties._box_id == boxId)[0];
      } else {
        boxItem = getCurrentCart.items.filter(item => item.properties._box_id == boxId && item.handle == "build-your-box")[0];
      }

      const arrOfHandles = boxItem.properties._box_options.split('|');
      arrOfHandles.forEach(itemHandle => {
        const itemId = document.querySelector(`[data-custom-product-handle="${itemHandle}"]`) && document.querySelector(`[data-custom-product-handle="${itemHandle}"] [data-add-to-box]`).getAttribute('data-product-id')
        changeValues(itemId);
      })
    } catch (error) {
      console.log(error);
      errorMessage.innerText = 'Unable to get items';
    }
  }

  async function updateCart(boxId, boxProductId, boxPrice) {
    const formData = new FormData();
    try {
      const getCurrentCart = await (await fetch('/cart.js')).json();
      let boxItem;

      if (BUNDLE_LOGIC === "custom") {
        boxItem = getCurrentCart.items.filter(item => item.properties._box_id == boxId)[0];
      } else {
        boxItem = getCurrentCart.items.filter(item => item.properties._box_id == boxId && item.handle == "build-your-box")[0];
      }

      const itemsToUpdate = getCurrentCart.items.filter(item => (item.properties._box_id == boxItem.properties._box_id && item.handle != 'build-your-box'));
      const quantity = boxItem.quantity;

      itemsToUpdate.forEach(item => {
        formData.append(`updates[${item.key}]`, 0);
      });
      formData.append(`updates[${boxItem.key}]`, 0);

      const response = await (await fetch('/cart/update.js', {
        method: 'POST',
        body: formData
      })).json();

      if (response) {
        addToCart(boxProductId, boxPrice);
      }
    } catch (error) {
      console.log(error);
      errorMessage.innerText = 'Unable to update item quantity';
    }
  }

  if (window.location.href.includes('#box_id') && saveToCartBtn && !localStorage.getItem('changingBoxId')) {
    const boxId = window.location.href.split('#box_id=')[1].split('&')[0]?.trim();
    const subscribePlan = window.location.href.split('subscribe_plan=')[1]?.trim();

    localStorage.setItem('changingBoxId', JSON.stringify(boxId));
    if (document.querySelectorAll('[data-add-box-to-cart]')) {
      document.querySelectorAll('[data-add-box-to-cart]').forEach((element) => {
        element.classList.add('d-none');
      })
    }
    if (document.querySelector('[data-save-box-to-cart]').classList.contains('d-none')) {
      document.querySelectorAll('[data-save-box-to-cart]').forEach((element) => {
        element.classList.remove('d-none');
      })
    }

    if (subscribePlan) {
      const subscribeInput = document.querySelector('.custom-sub-widget .custom-sub-widget__item--subscribe [name="subscribe-radio"]');
      const subscribeSelect = document.querySelector('.custom-sub-widget .custom-sub-widget__dropdown-select');

      if (subscribeInput) {
        subscribeInput.checked = true;
        const changeEvent = new Event('change', { 
          bubbles: true,
          cancelable: true
        });
        subscribeInput.dispatchEvent(changeEvent);

        if (subscribeSelect) {
          subscribeSelect.value = subscribePlan.replace("_", " ");
        }
      }
    }

    productFromCart(boxId);
  }

  addOnCheckbox.addEventListener('change', () => {
    recalculate();
  })

  addToBoxButtons.forEach((element) => {
    element.addEventListener('click', (e) => {
      e.stopPropagation();
      e.preventDefault();
      changeValues(element.getAttribute('data-product-id'))
    })
  })

  document.addEventListener('addToBox', (e) => {
    for (let i = 0; i < e.detail.qty; i++) {
      changeValues(e.detail.id);
    }
  })

  if (document.querySelector('[data-add-box-to-cart]')) {
    document.querySelectorAll('[data-add-box-to-cart]').forEach((element) => {
      element.addEventListener('click', function (e) {
        const boxProductId = e.target.getAttribute('data-box-product-id');
        let boxPrice
        if (e.target.parentElement.querySelector('[data-box-price]')) {
          boxPrice = e.target.parentElement.querySelector('[data-box-price]').getAttribute('data-box-price');
        } else {
          boxPrice = e.target.closest('.pb__mobile-fixed').querySelector('[data-box-price]').getAttribute('data-box-price');
        }
        addToCart(boxProductId, boxPrice);
      })
    })
  }

  if (document.querySelector('[data-save-box-to-cart]')) {
    document.querySelectorAll('[data-save-box-to-cart]').forEach((element) => {
      element.addEventListener('click', function (e) {
        const boxProductId = e.target.getAttribute('data-box-product-id');
        let boxPrice
        if (e.target.parentElement.querySelector('[data-box-price]')) {
          boxPrice = e.target.parentElement.querySelector('[data-box-price]').getAttribute('data-box-price');
        } else {
          boxPrice = e.target.closest('.pb__mobile-fixed').querySelector('[data-box-price]').getAttribute('data-box-price');
        }
        const boxId = window.location.href.split('#box_id=')[1].split('&')[0]?.trim();
        const subscribePlan = window.location.href.split('subscribe_plan=')[1]?.trim();

        if (subscribePlan) {
          const subscribeInput = document.querySelector('.custom-sub-widget .custom-sub-widget__item--subscribe [name="subscribe-radio"]');
          const subscribeSelect = document.querySelector('.custom-sub-widget .custom-sub-widget__dropdown-select');

          if (subscribeInput) {
            subscribeInput.checked = true;
            const changeEvent = new Event('change', { 
              bubbles: true,
              cancelable: true
            });
            subscribeInput.dispatchEvent(changeEvent);

            if (subscribeSelect) {
              subscribeSelect.value = subscribePlan;
            }
          }
        }

        updateCart(boxId, boxProductId, boxPrice).then(() => {
          localStorage.removeItem('handlesList');
          localStorage.removeItem('selectedProducts');
          localStorage.removeItem('changingBoxId');
          document.dispatchEvent(new CustomEvent("selectedProducts:updated"));
          if (document.querySelectorAll('[data-add-box-to-cart]')) {
            document.querySelectorAll('[data-add-box-to-cart]').forEach((element) => {
              element.classList.remove('d-none');
            })
          }
          if (document.querySelector('[data-save-box-to-cart]')) {
            document.querySelectorAll('[data-save-box-to-cart]').forEach((element) => {
              element.classList.add('d-none');
            })
          }
        });
      })
    })
  }

  if(document.querySelector('.pb__products-show-more')) {
    document.querySelector('.pb__products-show-more').addEventListener('click', () => {
      document.querySelectorAll('.pb__card--sm-hidden').forEach((element) => {
        element.classList.remove('pb__card--sm-hidden');
      })
      document.querySelector('.pb__products-show-more').style.display = 'none';
    })
  }

  document.querySelector('.pb__box-products-container') && document.querySelector('.pb__box-products-container').addEventListener('click', (e) => {
    if (e.target.closest('.pb__box-product-remove')) {
      removeProduct(e.target.closest('.pb__box-product-remove'));
    }
  })

  if (window.innerWidth < 992) {
    document.querySelector('.pb__mobile-row--products') && document.querySelector('.pb__mobile-row--products').addEventListener('click', (e) => {
      if (e.target.closest('.pb__box-product-remove')) {
        removeProduct(e.target.closest('.pb__box-product-remove'));
      }
    })
  }

  if (addToCartMobile) {
    const storageHandlesList = localStorage.getItem('handlesList') ? JSON.parse(localStorage.getItem('handlesList')) : [];
    const storageSelectedProducts = localStorage.getItem('selectedProducts') ? JSON.parse(localStorage.getItem('selectedProducts')) : [];
    let filledCells = 0;
    const qtyInput = document.querySelector('#quantity');
    storageSelectedProducts.forEach((item) => {
      filledCells += Number(item.size) * Number(item.quantity);
    })
    const availableValue = 6 - filledCells;
    if ((6 - filledCells) < Number(addToCartMobile.getAttribute('data-popup-product-size'))) {
      addToCartMobile.setAttribute('disabled', 'true');
    } else {
      qtyInput.setAttribute('max', Math.floor(availableValue / addToCartMobile.getAttribute('data-popup-product-size')).toString());
    }
    addToCartMobile.addEventListener('click', (e) => {
      e.preventDefault();
      storageSelectedProducts.push({
        'handle': addToCartMobile.getAttribute('data-handle'),
        'id': addToCartMobile.getAttribute('data-product-id'),
        'price': addToCartMobile.getAttribute('data-price'),
        'quantity': qtyInput.value,
        'size': addToCartMobile.getAttribute('data-popup-product-size'),
        'selling_plan': addToCartMobile.getAttribute('data-selling-plan')
      })
      for (let i = 0; i < Number(qtyInput.value); i++) {
        storageHandlesList.push(addToCartMobile.getAttribute('data-handle'));
      }
      localStorage.setItem('selectedProducts', JSON.stringify(storageSelectedProducts));
      localStorage.setItem('handlesList', JSON.stringify(storageHandlesList));
      document.dispatchEvent(new CustomEvent("selectedProducts:updated"));
      location.href = '/products/build-your-box';
    })
  }

  /**** On button click function ****/
  function changeValues(id) {
    const currentInput = document.querySelector(`input[data-id="${id}"]`);
    const currentImage = currentInput.getAttribute('data-image');
    const currentSize = currentInput.getAttribute('data-box-size');
    const currentCase = currentInput.getAttribute('data-case');
    const currentProduct = currentInput.getAttribute('data-handle');
    if (currentSize === '2') {
      if (!getCookie('sizeInfoClosed')) {
        document.getElementById('message_popup_overlay').style.display = 'flex';
        !document.querySelector('html').classList.contains('scroll-locked') && document.querySelector('html').classList.add('scroll-locked')
        document.getElementById('message_popup_overlay') && document.getElementById('message_popup_overlay').addEventListener('click', (e) => {
          if (!e.target.closest('#message_popup') || e.target.closest('.close_popup')) {
            document.querySelector('#message_popup_overlay').remove();
            document.querySelector('html').classList.contains('scroll-locked') && document.querySelector('html').classList.remove('scroll-locked')
          }
        })
        setCookie('sizeInfoClosed', 'true', 90);
      }
    }
    if (sizeValue < 7) {
      currentInput.value = +currentInput.value + 1;
      setImages(currentImage, currentSize, currentCase, id, currentProduct);
    }

    recalculate();
  }

  /**** Recalculate price, disabled cards, products in box ****/
  function recalculate() {
    let price = 0;
    selectedProducts = [];
    sizeValue = 0;

    document.querySelectorAll('[data-product-select]').forEach((item) => {
      const card = item.closest('.pb__card');
      if (Number(item.value) > 0) {
        card.classList.add('_active');
        sizeValue = sizeValue + Number(item.getAttribute('data-box-size')) * Number(item.value);
        price = price + Number(item.getAttribute('data-price')) * Number(item.value);
        selectedProducts.push({
          'handle': item.getAttribute('data-handle'),
          'id': item.getAttribute('data-id'),
          'price': item.getAttribute('data-price'),
          'quantity': item.value,
          'size': item.getAttribute('data-box-size'),
          'image': item.getAttribute('data-image'),
          'selling_plan': item.getAttribute('data-selling-plan')
        })
      } else {
        card.classList.remove('_active');
      }
    })

    if (selectedProducts.filter(product => product.handle.includes('favewich')).length > 0 && selectedProducts.filter(product => product.handle.includes('bakers-choice-hot-dog-buns') || product.handle.includes('bakers-choice-burger-buns')).reduce((acc, product) => acc + Number(product.quantity), 0) < 2) {
      document.querySelector('.pb__product-add-on').classList.remove('d-none');
      if (addOnCheckbox.checked) {
        price = price + Number(addOnCheckbox.getAttribute('data-add-on-product-price'));
      }
    } else {
      document.querySelector('.pb__product-add-on').classList.add('d-none');
    }
    const buttonText = (6 - sizeValue) > 1 ? `Pick ${6 - sizeValue} items` : `Pick ${6 - sizeValue} item`;
    enableCardButtons();
    if (sizeValue === 5) {
      document.querySelectorAll(('.pb__card:not(.js-unavailable)')).forEach((element) => {
        element.classList.remove('disabled')
      })
      document.querySelectorAll('[data-box-size="2"]').forEach((element) => {
        element.closest('.pb__card').classList.add('disabled');
        element.closest('.pb__card').classList.remove('_popup-short');
        element.closest('.pb__card').querySelector('.pb__card-popup-text').textContent = 'This item requires (2) sections of the box to be available.';
      })
      if (addToCartBtn) {
        document.querySelectorAll('[data-add-box-to-cart]').forEach((element) => {
          element.textContent = buttonText;
          element.setAttribute('disabled', 'true');
        })
      }
      if (saveToCartBtn) {
        document.querySelectorAll('[data-save-box-to-cart]').forEach((element) => {
          element.setAttribute('disabled', 'true');
        })
      }
    } else if (sizeValue === 6) {
      document.querySelectorAll(('.pb__card:not(.js-unavailable)')).forEach((element) => {
        element.classList.add('disabled');
        element.closest('.pb__card').classList.add('_popup-short');
        element.closest('.pb__card').querySelector('.pb__card-popup-text').textContent = 'The box is full.';
      })
      if (saveToCartBtn) {
        document.querySelectorAll('[data-save-box-to-cart]').forEach((element) => {
          element.removeAttribute('disabled');
        })
      }
      if (addToCartBtn) {
        document.querySelectorAll('[data-add-box-to-cart]').forEach((element) => {
          element.textContent = 'Add To Cart';
          element.removeAttribute('disabled');
        })
      }
    } else if (sizeValue < 5) {
      document.querySelectorAll(('.pb__card:not(.js-unavailable)')).forEach((element) => {
        element.classList.remove('disabled');
      })
      if (saveToCartBtn) {
        document.querySelectorAll('[data-save-box-to-cart]').forEach((element) => {
          element.setAttribute('disabled', 'true');
        })
      }
      if (addToCartBtn) {
        document.querySelectorAll('[data-add-box-to-cart]').forEach((element) => {
          element.textContent = buttonText;
          element.setAttribute('disabled', 'true');
        })
      }
    }

    document.querySelectorAll('[data-box-price]').forEach((element) => {
      element.textContent = '$' + (price / 100).toFixed(2);
      element.setAttribute('data-box-price', price);
    })
    disableCardButtons();

    localStorage.setItem('selectedProducts', JSON.stringify(selectedProducts));
    document.dispatchEvent(new CustomEvent("selectedProducts:updated"));
  }

  function disableCardButtons() {
    document.querySelectorAll(('.pb__card.disabled:not(.js-unavailable)')).forEach((element) => {
      element.querySelector('[data-add-to-box]').setAttribute('disabled', 'true');
    })
  }

  function enableCardButtons() {
    document.querySelectorAll(('.pb__card.disabled:not(.js-unavailable)')).forEach((element) => {
      element.querySelector('[data-add-to-box]').removeAttribute('disabled');
    })
  }

  /**** Add images to box ****/
  function setImages(image, size, caseCount, clickedId, clickedProduct) {
    let parentElement;
    const imageId = clickedId + '_' + addImgCount;
    addImgCount++;
    const caseCountText = caseCount.length ? '<div class="pb__case-count">' + caseCount + 'ea</div>' : '';
    if (size === '1') {
      parentElement = document.querySelector('.pb__box-container .pb__box-products-cell--empty');
      parentElement && parentElement.classList.remove('pb__box-products-cell--empty');
      if (parentElement.closest('.pb__box-products-row--empty')) {
        parentElement.closest('.pb__box-products-row--empty').classList.remove('pb__box-products-row--empty');
      }
    } else {
      parentElement = document.querySelector('.pb__box-container .pb__box-products-row--empty');
      if (!parentElement && document.querySelectorAll('.pb__box-container .pb__box-products-cell--empty').length > 1) {
        const availableCell = document.querySelector('.pb__box-container .pb__box-products-cell--empty');
        const cellsWithImages = document.querySelectorAll('.pb__box-container .pb__box-products-cell:not(.pb__box-products-cell--empty)');
        const lastCellData = cellsWithImages[cellsWithImages.length - 1].querySelector('.pb__box-container .pb__box-product-image').cloneNode(true);
        availableCell.textContent = '';
        availableCell.appendChild(lastCellData);
        availableCell.classList.remove('pb__box-products-cell--empty');
        cellsWithImages[cellsWithImages.length - 1].textContent = '';
        cellsWithImages[cellsWithImages.length - 1].innerHTML = emptySvgHTML;
        cellsWithImages[cellsWithImages.length - 1].classList.add('pb__box-products-cell--empty');
        document.querySelectorAll('.pb__box-products-row').forEach((element) => {
          if (element.querySelectorAll('.pb__box-products-cell--empty').length > 1) {
            parentElement = element;
          }
        })
      }
      parentElement && parentElement.classList.remove('pb__box-products-row--empty');
    }
    if (parentElement) {
      parentElement.innerHTML = '<div class="pb__box-product-image" data-box-product-handle="' + clickedProduct + '" data-box-product-size="' + size + '" data-box-product-id="' + clickedId + '" data-image-id="' + imageId + '">' +
        '<button type="button" class="pb__box-product-remove" data-remove-id="' + clickedId + '"><svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
        '<path d="M10.4122 1.86931C10.4988 1.78575 10.5679 1.68578 10.6155 1.57524C10.663 1.4647 10.6881 1.34579 10.6892 1.22546C10.6903 1.10513 10.6674 0.985785 10.6219 0.87439C10.5764 0.762994 10.5091 0.661778 10.4241 0.576648C10.339 0.491518 10.2379 0.424179 10.1265 0.378559C10.0152 0.332939 9.89583 0.309954 9.7755 0.310942C9.65517 0.311931 9.53624 0.336874 9.42565 0.384317C9.31507 0.43176 9.21503 0.500752 9.13139 0.587267L5.49914 4.21831L1.8681 0.587267C1.78513 0.498229 1.68508 0.426814 1.57392 0.377282C1.46275 0.32775 1.34275 0.301116 1.22107 0.298969C1.09938 0.296822 0.978514 0.319206 0.86567 0.364786C0.752826 0.410366 0.650319 0.478207 0.564263 0.564263C0.478207 0.650319 0.410366 0.752826 0.364786 0.86567C0.319206 0.978514 0.296822 1.09938 0.298969 1.22107C0.301116 1.34275 0.32775 1.46275 0.377282 1.57392C0.426814 1.68508 0.498229 1.78513 0.587267 1.8681L4.21589 5.50035L0.584851 9.13139C0.424771 9.30319 0.337622 9.53041 0.341764 9.76519C0.345907 9.99997 0.441017 10.224 0.607058 10.39C0.773099 10.5561 0.997105 10.6512 1.23189 10.6553C1.46667 10.6595 1.69389 10.5723 1.86568 10.4122L5.49914 6.78119L9.13019 10.4134C9.30198 10.5735 9.5292 10.6607 9.76398 10.6565C9.99876 10.6524 10.2228 10.5573 10.3888 10.3912C10.5549 10.2252 10.65 10.0012 10.6541 9.7664C10.6582 9.53162 10.5711 9.3044 10.411 9.1326L6.78239 5.50035L10.4122 1.86931Z" fill="#323232"/>\n' +
        '</svg>\n</button>' +
        caseCountText +
        '<img src="' + image + '" alt="Box Image">' +
        '</div>'
    }
    setHandlesList();
    if (window.innerWidth < 992) {
      setMobileImages(image, size, caseCount, clickedId, clickedProduct, imageId)
    }
  }

  function setMobileImages(image, size, caseCount, clickedId, clickedProduct, imageId) {
    let parentElement;
    const caseCountText = caseCount.length ? '<div class="pb__case-count">' + caseCount + 'ea</div>' : '';
    if (size === '1') {
      parentElement = document.querySelector('.pb__mobile-fixed .pb__box-products-cell--empty');
      parentElement && parentElement.classList.remove('pb__box-products-cell--empty');
      if (parentElement.closest('.pb__box-products-row--empty')) {
        parentElement.closest('.pb__box-products-row--empty').classList.remove('pb__box-products-row--empty');
      }
    } else {
      parentElement = document.querySelector('.pb__mobile-fixed .pb__box-products-row--empty');
      if (!parentElement && document.querySelectorAll('.pb__mobile-fixed .pb__box-products-cell--empty').length > 1) {
        const availableCell = document.querySelector('.pb__mobile-fixed .pb__box-products-cell--empty');
        const cellsWithImages = document.querySelectorAll('.pb__mobile-fixed .pb__box-products-cell:not(.pb__box-products-cell--empty)');
        const lastCellData = cellsWithImages[cellsWithImages.length - 1].querySelector('.pb__mobile-fixed .pb__box-product-image').cloneNode(true);
        availableCell.textContent = '';
        availableCell.appendChild(lastCellData);
        availableCell.classList.remove('pb__box-products-cell--empty');
        cellsWithImages[cellsWithImages.length - 1].textContent = '';
        cellsWithImages[cellsWithImages.length - 1].innerHTML = emptySvgHTML;
        cellsWithImages[cellsWithImages.length - 1].classList.add('pb__box-products-cell--empty');
        document.querySelectorAll('.pb__box-products-row').forEach((element) => {
          if (element.querySelectorAll('.pb__box-products-cell--empty').length > 1) {
            parentElement = element;
          }
        })
      }
      parentElement && parentElement.classList.remove('pb__box-products-row--empty');
    }
    if (parentElement) {
      parentElement.innerHTML = '<div class="pb__box-product-image" data-box-product-handle="' + clickedProduct + '" data-image-id="' + imageId + '" data-box-product-size="' + size + '" data-box-product-id="' + clickedId + '">' +
        '<button type="button" class="pb__box-product-remove" data-remove-id="' + clickedId + '"><svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
        '<path d="M10.4122 1.86931C10.4988 1.78575 10.5679 1.68578 10.6155 1.57524C10.663 1.4647 10.6881 1.34579 10.6892 1.22546C10.6903 1.10513 10.6674 0.985785 10.6219 0.87439C10.5764 0.762994 10.5091 0.661778 10.4241 0.576648C10.339 0.491518 10.2379 0.424179 10.1265 0.378559C10.0152 0.332939 9.89583 0.309954 9.7755 0.310942C9.65517 0.311931 9.53624 0.336874 9.42565 0.384317C9.31507 0.43176 9.21503 0.500752 9.13139 0.587267L5.49914 4.21831L1.8681 0.587267C1.78513 0.498229 1.68508 0.426814 1.57392 0.377282C1.46275 0.32775 1.34275 0.301116 1.22107 0.298969C1.09938 0.296822 0.978514 0.319206 0.86567 0.364786C0.752826 0.410366 0.650319 0.478207 0.564263 0.564263C0.478207 0.650319 0.410366 0.752826 0.364786 0.86567C0.319206 0.978514 0.296822 1.09938 0.298969 1.22107C0.301116 1.34275 0.32775 1.46275 0.377282 1.57392C0.426814 1.68508 0.498229 1.78513 0.587267 1.8681L4.21589 5.50035L0.584851 9.13139C0.424771 9.30319 0.337622 9.53041 0.341764 9.76519C0.345907 9.99997 0.441017 10.224 0.607058 10.39C0.773099 10.5561 0.997105 10.6512 1.23189 10.6553C1.46667 10.6595 1.69389 10.5723 1.86568 10.4122L5.49914 6.78119L9.13019 10.4134C9.30198 10.5735 9.5292 10.6607 9.76398 10.6565C9.99876 10.6524 10.2228 10.5573 10.3888 10.3912C10.5549 10.2252 10.65 10.0012 10.6541 9.7664C10.6582 9.53162 10.5711 9.3044 10.411 9.1326L6.78239 5.50035L10.4122 1.86931Z" fill="#323232"/>\n' +
        '</svg>\n</button>' +
        caseCountText +
        '<img src="' + image + '" alt="Box Image">' +
        '</div>'
    }
  }

  function removeProduct(element) {
    let parentElement;
    const size = element.closest('.pb__box-product-image').getAttribute('data-box-product-size');
    const id = element.closest('.pb__box-product-image').getAttribute('data-box-product-id');
    const imageId = element.closest('.pb__box-product-image').getAttribute('data-image-id');
    const removedProductInput = document.querySelector(`input[data-id="${id}"]`);
    const removedElements = document.querySelectorAll(`[data-image-id="${imageId}"]`);
    if (size === '1') {
      removedElements.forEach((itemElement) => {
        parentElement = itemElement.closest('.pb__box-products-cell');
        parentElement.classList.add('pb__box-products-cell--empty');
        parentElement.innerHTML = '';
        parentElement.innerHTML = emptySvgHTML;
        if (parentElement.closest('.pb__box-products-row').querySelectorAll('.pb__box-products-cell--empty').length === 2) {
          parentElement.closest('.pb__box-products-row').classList.add('pb__box-products-row--empty');
        }
      })
    } else {
      removedElements.forEach((itemElement) => {
        parentElement = itemElement.closest('.pb__box-products-row');
        parentElement.classList.add('pb__box-products-row--empty');
        parentElement.innerHTML = '';
        parentElement.innerHTML = `<div class="pb__box-products-cell pb__box-products-cell--empty">${emptySvgHTML}</div><div class="pb__box-products-cell pb__box-products-cell--empty">${emptySvgHTML}</div>`;
      })
    }
    removedProductInput.value = +removedProductInput.value - 1;
    setHandlesList();
  }

  function setHandlesList() {
    handlesList = [];
    document.querySelectorAll('.pb__box-container .pb__box-product-image').forEach((element) => {
      handlesList.push(element.getAttribute('data-box-product-handle'));
    })
    localStorage.setItem('handlesList', JSON.stringify(handlesList));
    recalculate();
  }

  function addToCart(boxProductId, boxPrice, oldQuantity) {
    const boxId = Date.now().toString();
    const productSubscriptionData = document.getElementById('product_subscription_data') ? JSON.parse(document.getElementById('product_subscription_data').innerText) : [];
    const subscriptionInput = document.querySelector('#subscribe-input-radio:checked');
    const subscriptionSelect = document.querySelector('.custom-sub-widget__dropdown-select');
    const formData = {
      'items': []
    };

    let addOnHandle = '';
    if (addOnCheckbox.checked && !document.querySelector('.pb__product-add-on').classList.contains('d-none')) {
      addOnHandle = addOnCheckbox.getAttribute('data-box-product-handle');
      handlesList.push(addOnHandle);

      const addonItem = {
        'id': addOnCheckbox.getAttribute('data-add-on-product-id'),
        'quantity': 1,
        'properties': {
          '_box_id': boxId,
          '_box_quantity': 1,
          '_box_price': boxPrice,
          '_box_options': handlesList.join('|'),
          '_box_add_on_handle': addOnHandle
        }
      };

      if (subscriptionInput && subscriptionSelect && subscriptionSelect.value && productSubscriptionData.length) {
        const currentProduct = productSubscriptionData.find(product => product.handle === addOnHandle);
        if (currentProduct && currentProduct.selling_plan_groups) {
          const currentVariant = currentProduct.variants[0];
          if (currentVariant) {
            const currentSellingPlan = currentVariant.selling_plan_allocations.find(allocation => allocation.selling_plan.name === subscriptionSelect.value.trim());
            if (currentSellingPlan) {
              addonItem.selling_plan = currentSellingPlan.selling_plan.id;
            }
          }
        }
      }

      formData.items.push(addonItem);
    }

    selectedProducts.forEach((item) => {
      const cartItem = {
        id: item.id,
        quantity: oldQuantity ? oldQuantity * item.quantity : item.quantity,
        properties: {
          _box_id: String(boxId),
          _box_quantity: String(item.quantity),
          _box_price: String(boxPrice),
          _box_options: String(handlesList.join("|"))
        },
      };

      if (subscriptionInput && subscriptionSelect && subscriptionSelect.value && productSubscriptionData.length) {
        const currentProduct = productSubscriptionData.find(product => product.handle === item.handle);
        if (currentProduct && currentProduct.selling_plan_groups) {
          const currentVariant = currentProduct.variants.find(variant => variant.id.toString() === item.id.toString());
          if (currentVariant) {
            const currentSellingPlan = currentVariant.selling_plan_allocations.find(allocation => allocation.selling_plan.name === subscriptionSelect.value.trim());
            if (currentSellingPlan) {
              cartItem.selling_plan = currentSellingPlan.selling_plan.id;
            }
          }
        }
      }

      formData.items.push(cartItem);
    });

    window.fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
      .then(response => response.json())
      .then((data) => {
        if(data.message) {
          //Error
          new Modal({
            title: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-triangle-alert"><path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3"/><path d="M12 9v4"/><path d="M12 17h.01"/></svg>`,
            text: data.message,
            immediate: true,
            className: ['modal--error']
          });
        } else {

          window.fetch('/cart.js', {
            method: 'GET',
            credentials: 'same-origin',
            headers: {
              'Content-Type': 'application/json'
            }
          })
            .then((cart) => cart.text())
            .then((cart) => {
              window.wetheme.cartDrawer.updateCartDrawer(JSON.parse(cart));
              const event = new CustomEvent('cart:open');
              document.querySelector('#cartSlideoutWrapper').dispatchEvent(event);
              document.querySelectorAll('.pb__box-product-remove').forEach((element) => {
                removeProduct(element);
              })
              document.querySelectorAll('[data-product-select]').forEach((element) => {
                element.value = '0';
              })
              localStorage.removeItem('handlesList');
              localStorage.removeItem('selectedProducts');
              document.dispatchEvent(new CustomEvent("selectedProducts:updated"));

              window.history.replaceState({}, "", window.location.pathname + window.location.search);
          });
        }
      })
      .catch((error) => {
        console.error('Error:', error);
      });

  }

  function setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    const expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }

  function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  const cardElement = document.querySelector('.pb__mobile-fixed');
  const boxContainer = document.querySelector('.pb__column--box');
  if (boxContainer) {
    window.addEventListener("scroll", function () {
      if (window.innerWidth < 992) {
        const elementYPosition = boxContainer.getBoundingClientRect().y;
        const elementHeight = boxContainer.getBoundingClientRect().height
        const viewportTop = document.querySelector('.mobile-header--wrapper').getBoundingClientRect().height - elementHeight;
        const viewportHeight = window.innerHeight;

        if (elementYPosition > viewportTop && elementYPosition < viewportHeight) {
          if (cardElement && cardElement.classList.contains('is-visible')) {
            cardElement.classList.remove('is-visible');
          }
        } else {
          if (cardElement && !cardElement.classList.contains('is-visible')) {
            cardElement.classList.add('is-visible');
          }
        }
      }
    })
  }
})

window.addEventListener('pagehide', () => {
  localStorage.removeItem('changingBoxId');
})


document.addEventListener("change", function(e) {
  if (!e.target) return;

  const url = new URL(window.location.href);

  if (window.location.hash) {
    const hash = window.location.hash.substring(1);
    const params = new URLSearchParams(hash);

    if (params.has("subscribe_plan")) {
      params.delete("subscribe_plan");

      const newHash = params.toString();
      const newUrl = window.location.pathname + window.location.search + (newHash ? "#" + newHash : "");

      window.history.replaceState({}, "", newUrl);
    }
  }
});